import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule} from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AngularUiCommonModule } from '../../submodules/angular-ui-common/angular-ui-common.module';
import { PublicAreaRoutingModule } from './public-area-routing.module';
import { PublicAreaComponent } from './components/public-area.component';
import { HomeComponent } from './components/home/home.component';
import { AboutUsComponent } from './components/about-us/about-us.component';
import { ContactsComponent } from './components/contacts/contacts.component';
import { CookiePolicyComponent } from './components/cookie-policy/cookie-policy.component';
import { JwplayerComponent } from './components/jwplayer/jwplayer.component';
import { CarouselComponent } from './components/carousel/carousel.component';
import { TeamComponent } from './components/team/team.component';
import { PresentationComponent } from './components/presentation/presentation.component';
import { ServicesComponent } from './components/services/services.component';
import { HomeFooterComponent } from './components/home-footer/home-footer.component';
import { HomeFormComponent } from './components/home-form/home-form.component';
import { DeviceDetectorService } from 'ngx-device-detector';

@NgModule({
  declarations: [
    PublicAreaComponent,
    HomeComponent,
    AboutUsComponent,
    ContactsComponent,
    CookiePolicyComponent,
    JwplayerComponent,
    CarouselComponent,
    TeamComponent,
    PresentationComponent,
    ServicesComponent,
    HomeFooterComponent,
    HomeFormComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
  
    // routing
    PublicAreaRoutingModule,

    // i18n
    TranslateModule,

    // app
    AngularUiCommonModule
  ],
  providers: [DeviceDetectorService],
  exports: [                 //<- componenti da utilizzare anche fuori da questo modulo
    PublicAreaComponent
  ],
})
export class PublicAreaModule {
  constructor() {
    console.log('PublicAreaModule loaded.');
  }
}
